import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";

// Register chart components
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export default function ReportGraph({ reports = [], activeTab }) {
  if (!Array.isArray(reports) || reports.length === 0) {
    return null;
  }

  // ✅ Show only site names on X-axis
  const labels = reports.map((r) => r.site || "Unknown Site");

  // Water dispensed (numeric parsing)
  const waterData = reports.map((r) =>
    parseFloat(
      r?.totalWaterDispensed?.$numberDecimal || r.totalWaterDispensed || 0
    )
  );

  const data = {
    labels,
    datasets: [
      {
        label: "Water Dispensed (L)",
        data: waterData,
        backgroundColor: "rgba(54, 162, 235, 0.7)",
      },
    ],
  };

  const xLabel =
    activeTab === "daily"
      ? "Site"
      : activeTab === "monthly"
      ? "Site"
      : "Site";

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: xLabel,
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Liters",
        },
      },
    },
  };

  return (
    <div
      style={{
        marginTop: "40px",
        padding: "20px",
        backgroundColor: "#fff",
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
        Water Dispensed Overview
      </h3>
      <Bar data={data} options={options} />
    </div>
  );
}
